import * as React from 'react';
import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Typography } from '@mui/material';

import { withMicrofrontend } from 'utils/microfrontend/useMicrofrontend';
import { getAuthorizationHeader } from 'utils/microfrontend/api';
import { serverUri } from 'utils/config';
import { useRootStore } from 'stores/RootStore';

interface CompDatabaseProps {
  compplexLoaded?: boolean;
  showCapRateSummary?: boolean;
}

const CompDatabase: React.FC<CompDatabaseProps> = observer(({ compplexLoaded, showCapRateSummary }) => {
  const { authStore } = useRootStore();
  const { currentUser } = authStore;

  const compplexRef = useRef<CompPlexElement>(null);

  useEffect(() => {
    if (compplexLoaded && compplexRef?.current) {
      const currentCompplexRef = compplexRef.current;

      currentCompplexRef['webapp-auth-header'] = getAuthorizationHeader().Authorization;
      currentCompplexRef['webapp-api-url'] = serverUri || '';
    }
  }, [compplexLoaded, compplexRef]);

  return (
    <Grid>
      {compplexLoaded ? (
        <comp-plex-properties
          ref={compplexRef}
          auth-user={JSON.stringify(currentUser)}
          webapp-auth-header={getAuthorizationHeader().Authorization}
          webapp-api-url={serverUri || ''}
          client-portal={true}
          has-costar-license={false}
          show-cap-rate-summary={showCapRateSummary}
        />
      ) : (
        <Grid item xs={12}>
          <Typography variant="body1" align="center" py={4}>
            Loading Comp Database...
          </Typography>
        </Grid>
      )}
    </Grid>
  );
});

export default withMicrofrontend('compplex', 'compplexLoaded')(CompDatabase);
